// extracted by mini-css-extract-plugin
export default {"tooltip":"ZW-z","arrow":"_W-z"};